import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";


import BubbleLogo from "./images/bubble-logo";
import TopLogo from "./images/top-logo"
import BottomRow from "./bottom-row";
import {EXTRA_SCREEN, PLAY_SCREEN} from '../../ducks/duck-screen'
import {getTranslation} from "../../helpers/get-translation";
import {wheelModal} from "../../helpers/modal-builder";

const styles = theme => ({
	root: {
		flexGrow: 1,
		height: "100%",
		overflowY: 'auto',
		overflowScrolling: "touch",
		WebkitOverflowScrolling: "touch",
		overscrollBehavior: "none",
		overflowX: 'hidden'
	},
	bottomLogo: {
		backgroundPosition: "center bottom, left bottom, right bottom",
		backgroundRepeat: "no-repeat, no-repeat no-repeat",
		backgroundImage: `url("${getTranslation("image_main_bottom_banner")}"), url("${getTranslation("image_main_bottom_left")}"), url("${getTranslation("image_main_bottom_right")}")`,
		backgroundSize: "100%, 30%, 30%"
	},
	center: {
		margin: "1vh auto"
	},
	gridButtonContainer: {
		padding: "6px !important",
		width: "100%"
	},
	button: {
		width: "100%",
		fontSize: "15px"
	},
	playButton: {
		backgroundColor: "#ff2d55",
		"&:hover": {
			backgroundColor: "#c4002d"
		}
	},
	hintsButton: {
		backgroundColor: "#4bd963",
		"&:hover": {
			backgroundColor: "#00a634"
		}
	},
	bubbleLogo: {
		marginTop: "0"
	},
	"@media (max-height: 500px)": {
		root: {
			backgroundImage: "none"
		}
	},
	"@media (max-height: 660px) and (min-width: 768px)": {
		root: {
			backgroundImage: "none"
		}
	},
	"@media (max-width: 730px)": {
		bubbleLogo: {
			marginTop: "0"
		}
	},
	"@media (max-width: 768px) and (min-height: 640px)": {
		bubbleLogo: {
			marginTop: "5vh"
		}
	},
	"@media (max-width: 768px) and (min-height: 730px)": {
		bubbleLogo: {
			marginTop: "15vh"
		}
	}
});

function MainScreen(props) {
	const { classes,
		push,
		addModalWindow,
		setCurrentGameType } = props;
	const buttonWidth = 9;
	return (
		<div className={[classes.root, classes.bottomLogo].join(" ")}>

			<TopLogo />

			<div className={classes.gridContentContainer}>
				<Grid
					container
					spacing={3}
					wrap="nowrap"
					direction="column"
					justify="space-between"
				>
					{/*PLAY BUTTON*/}
					<Grid
						item
						xs={buttonWidth}
						className={`${classes.gridButtonContainer} ${classes.center}`}
					>
						<Button
							id="play-button"
							variant="contained"
							color="primary"
							className={`${classes.button} ${classes.playButton}`}
							onClick={e => {
								setCurrentGameType('classic');
								push(PLAY_SCREEN);
							}}
						>
							{getTranslation('main_play_button')}
						</Button>
					</Grid>

					{/*EXTRA LEVELS BUTTON*/}
					<Grid
						item
						xs={buttonWidth}
						className={`${classes.gridButtonContainer} ${classes.center}`}
					>
						<Button
							id="extra-levels-button"
							variant="contained"
							color="secondary"
							className={classes.button}
							onClick={e => {
								push(EXTRA_SCREEN);
							}}
						>
							{getTranslation('main_extra_levels_button')}
						</Button>
					</Grid>

					{/*GET HINTS BUTTON*/}
					<Grid
						item
						xs={buttonWidth}
						className={`${classes.gridButtonContainer} ${classes.center}`}
					>
						<Button
							id="get-hints-button"
							variant="contained" //TODO
							className={`${classes.button} ${classes.hintsButton} ` } onClick={e => addModalWindow(wheelModal())}
						>
							{getTranslation('main_hints_button')}
						</Button>
					</Grid>

					<Grid item className={classes.center}>
						<BottomRow push={push}/>
					</Grid>

					{/*<BottomImage />*/}
					<Grid item xs={9} className={`${classes.center} ${classes.bubbleLogo}`}>
						<BubbleLogo />
					</Grid>
				</Grid>
			</div>

			{/*<div className={classes.logo}>*/}
				{/*<img src={getTranslation("image_main_top_banner")} alt="Logo quiz"/>*/}
			{/*</div>*/}

		</div>
		// <div>
		//
		// </div>
	);
}

MainScreen.propTypes = {

	classes: PropTypes.shape({
		root: PropTypes.string.isRequired,
		playButton: PropTypes.string.isRequired,
		bubbleLogo: PropTypes.string.isRequired,
		gridButtonContainer: PropTypes.string.isRequired,
		button: PropTypes.string.isRequired
	}).isRequired,

	push: PropTypes.func.isRequired,
	addModalWindow: PropTypes.func.isRequired,
	setCurrentGameType: PropTypes.func.isRequired,
};

export default withStyles(styles)(MainScreen);
